"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCell = exports.TableRow = exports.TableBody = exports.TableHeading = exports.TableHead = exports.Table = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@material-ui/core/styles");

var _UnfoldMore = _interopRequireDefault(require("@material-ui/icons/UnfoldMore"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TableWrapper = _styledComponents.default.div`
	height: 100%;
	width: 100%;
	min-height: 40px;
`;
const StyledTable = _styledComponents.default.table`
	border-collapse: collapse;
	width: 100%;
	display: table;
	border-spacing: 0;

	th {
		${({
  stickyHeader
}) => stickyHeader && `
				position: sticky;
				top: 0;
				z-index: 990;
		`}

		${({
  stickyCol
}) => stickyCol && `
			&:first-child {
				position: sticky;
				left: 0;
				z-index:1000;
			}
		`}
	}

	${({
  rowHover
}) => rowHover && `
		tbody {
			tr:hover {
				box-shadow: ${_constants.shadows.tableRowHover};
				transform: scale(1);
				background-color: ${_constants.colours.white};

				&:nth-child(2n) {
					td {
						border-color: ${_constants.colours.paleGrey};
					}
				}

				td {
					position: relative;
					border-color: transparent;

					&:first-child {
						&:before {
							position: absolute;
							content: '';
							display: block;
							width: 4px;
							height: 100%;
							background-color: ${_constants.colours.primary};
							left: 0;
							top: 0;
						}
					}
				}
			}
		}
	`}

	${({
  isSlim
}) => !isSlim && `
			@media (min-width: ${_constants.breakpoints.tablet}) {
				th:first-child,
				td:first-child {
					padding-left: 50px;
				}

				th:last-child,
				td:last-child {
					padding-right: 50px;
				}
			}
		`}

  ${({
  stickyCol
}) => stickyCol && `
			tr {
				td {
					&:first-child {
						position: sticky;
						left: 0;
						z-index: 999;
					}
					
					&:after {
						border-right: 1px solid ${_constants.colours.mediumGrey};
						position: absolute;
						content: "";
						top: 0;
						bottom: 0;
						right: 0;
					}
				}
			}
	`}
`;
const StyledHead = _styledComponents.default.thead`
	display: table-header-group;
	position: relative;
`;
const StyledHeading = _styledComponents.default.th`
	border-right: 1px solid ${_constants.colours.white};
	padding: 20px 10px;
	font-size: ${_constants.fontSizes.detail2};
	background-color: ${_constants.colours.lightGrey};
	text-align: left;
	min-height: 70px;
	vertical-align: top;

	${({
  isColumnResizable
}) => isColumnResizable && `
			resize: horizontal;
			overflow: hidden;
	`}

	${({
  isSmallColumn
}) => isSmallColumn && `
		width: 115px;
	`}
`;
const StyledBody = _styledComponents.default.tbody`
	display: table-row-group;
`;
const StyledRow = _styledComponents.default.tr`
	position: relative;
	display: table-row;
	outline: 0;
	vertical-align: middle;

	&:nth-child(2n) {
		td {
			background-color: ${_constants.colours.paleGrey};
		}
	}

	&& td {
		${({
  isRowActive
}) => isRowActive && `
			  background-color: ${_constants.colours.tableRowSelected};
			  color: ${_constants.colours.white};
			  `}
		${({
  isRowInvalid
}) => isRowInvalid && `
			background-color: ${_constants.colours.tableRowInvalid};
			`}
	}
`;
const StyledCell = _styledComponents.default.td`
	padding: 20px 10px;
	vertical-align: top;
	white-space: break-spaces;
	text-overflow: ellipsis;
	overflow: hidden;
	background-color: white;

	&:not(:last-child) {
		border-right: 1px solid ${_constants.colours.mediumGrey};
	}
`;
const StyledIcon = (0, _styles.withStyles)({
  root: {
    flex: 'none',
    padding: 0,
    float: 'right',
    transform: 'translate(3px, 0px)',
    '&:hover': {
      backgroundColor: 'unset'
    }
  }
})(_IconButton.default);

const Wrapper = ({
  stickyHeader,
  stickyCol,
  children,
  ...props
}) => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, stickyCol || stickyHeader ? /*#__PURE__*/_react.default.createElement(TableWrapper, props, children) : /*#__PURE__*/_react.default.createElement("div", null, children));
};

const Table = ({
  children,
  isSlim = false,
  rowHover,
  stickyCol,
  stickyHeader,
  afterTable,
  ...rest
}) => /*#__PURE__*/_react.default.createElement(Wrapper, {
  stickyHeader: stickyHeader,
  stickyCol: stickyCol
}, /*#__PURE__*/_react.default.createElement(StyledTable, _extends({
  isSlim: isSlim,
  rowHover: rowHover,
  stickyCol: stickyCol,
  stickyHeader: stickyHeader
}, rest), children), afterTable);

exports.Table = Table;

const TableHead = ({
  children
}) => /*#__PURE__*/_react.default.createElement(StyledHead, null, children); // TODO - add active blue state to <th> when adding in Table Sorter Dropdown


exports.TableHead = TableHead;

const TableHeading = ({
  children,
  action,
  isColumnResizable,
  isSmallColumn,
  ...rest
}) => /*#__PURE__*/_react.default.createElement(StyledHeading, _extends({
  onClick: action && action,
  isColumnResizable: isColumnResizable,
  isSmallColumn: isSmallColumn
}, rest), action ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledIcon, {
  "aria-label": "Heading action"
}, /*#__PURE__*/_react.default.createElement(_UnfoldMore.default, null)), children) : children);

exports.TableHeading = TableHeading;

const TableBody = ({
  children,
  ...rest
}) => /*#__PURE__*/_react.default.createElement(StyledBody, rest, children);

exports.TableBody = TableBody;

const TableRow = ({
  children,
  isRowActive,
  isRowInvalid,
  ...rest
}) => {
  return /*#__PURE__*/_react.default.createElement(StyledRow, _extends({
    isRowActive: isRowActive,
    isRowInvalid: isRowInvalid
  }, rest), children);
};

exports.TableRow = TableRow;

const TableCell = ({
  children,
  ...rest
}) => /*#__PURE__*/_react.default.createElement(StyledCell, rest, children);

exports.TableCell = TableCell;